import { SettingsPermissions } from "@redotech/account-common/permissions";
import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import Globe02Icon from "@redotech/redo-icons/globe-02.svg";
import Globe02FilledIcon from "@redotech/redo-icons/globe-02_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useCapability } from "@redotech/redo-merchant-app-common/use-capability";
import { memo } from "react";

export const MarketsItems = memo(function MarketsItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const landedCostEnabled = useCapability("landedCost");
  const canManageFulfillment = useHasPermission(
    SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
  );

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConversionSubRoute("markets") }}
      FilledIcon={Globe02FilledIcon}
      friendlyName={t("Markets", {
        context:
          "checkout conversion navigation label for international markets",
      })}
      hidden={!landedCostEnabled || !canManageFulfillment}
      id="markets"
      UnfilledIcon={Globe02Icon}
    />
  );
});
